// Time period used as the default value for historical data
export const DEFAULT_HISTORICAL_ANALYSIS_DATA_TIME_PERIOD = 86400000;

// Time formatting related constants
export const HOUR_24_WITH_MINUTES = "24.00";
export const HOUR_00_WITH_MINUTES = "00.00";
export const MILLISECONDS_TO_HOUR = 3600000;
export const MILLISECONDS_TO_MINUTE = 1000 * 60;
export const MILLISECONDS_TO_SECONDS = 1000;
export const MINUTES_TO_HOUR = 60;
export const HOUR_24 = 24;
export const MILLISECONDS_TO_DAY = MILLISECONDS_TO_HOUR * HOUR_24;

export const DATE_FORMAT_WITH_SECONDS = "dd/MM/yyyy hh:mm:ss aaa";
export const DEFAULT_DATE_FORMAT = "dd/MM/yyyy hh:mm aaa";
export const DEFAULT_DATE_FORMAT_WITH_TIMEZONE = `${DEFAULT_DATE_FORMAT} zzz`;
export const DEFAULT_DISPLAY_TIMEZONE = "Australia/Sydney";
export const MINUTES_15_IN_MILLISECOND = 15 * 60 * 1000;
export const ONE_DAY_IN_MILLISECOND = 24 * 60 * 60 * 1000;
export const RETENTION_PERIOD_IN_DAYS = 30; // In days
export const ISO_DATE_VALIDATION_REGEX =
    // eslint-disable-next-line max-len
    /^[0-9]{4}-((0[13578]|1[02])-(0[1-9]|[12][0-9]|3[01])|(0[469]|11)-(0[1-9]|[12][0-9]|30)|(02)-(0[1-9]|[12][0-9]))T(0[0-9]|1[0-9]|2[0-3]):(0[0-9]|[1-5][0-9]):(0[0-9]|[1-5][0-9])\.[0-9]{3}Z$/;
export const MANUAL_VIDEO_REQUEST_MAX_DURATION_IN_MINUTES = 30;
